import type { ConfigProviderProps } from 'antd/es/config-provider';

/* `select.suffixIcon` covers the closed state only: with no `suffixIcon` prop, antd resolves the
   icon per render from `{ open, showSearch }` and reads `searchIcon` -- not this key -- while a
   searchable popup is open (select/useIcons.js:57-64). ui/base/Select passes the same node there. */
export const selectArrowIcon = <span className="fb-icon--arrow-down" />;

const selectConfig: ConfigProviderProps['select'] = {
  suffixIcon: selectArrowIcon,
};

export default selectConfig;
